import { getLocalStorageItem, setLocalStorageItem } from 'app/api/localStorage'
import { useAppSelector } from 'app/state'
import { LogInProviders } from 'features/users'
import settings from 'settings'

function useLoginHelper() {
  const user = useAppSelector((state) => state.users.me)
  const isStudent = user?.identities?.some((identity) => identity.provider === LogInProviders.GitHub)
  const wasLoggedInAsStudent = Boolean(getLocalStorageItem(settings.loginAsStudentKey))

  const markAsStudentLogin = () => {
    setLocalStorageItem(settings.loginAsStudentKey, true)
  }

  return { wasLoggedInAsStudent, isStudent, markAsStudentLogin }
}

export default useLoginHelper
